module.exports = __webpack_public_path__ + "static/news-11-banner-560a255bee13bfafb51b0cd44945ed66.png";